import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestModalComponent } from './components/test-modal/test-modal.component';
import { TestComponentComponent } from './features/test-component/test-component.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { onError } from '@apollo/client/link/error';
import { HttpClientModule } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import {
  ActionBarModule,
  BoxModule,
  CalendarViewModule,
  CardModule,
  DataTableModule,
  DrawerModule,
  DropdownModule,
  FormModule,
  GridModule,
  HeadingModule,
  IconModule,
  LabelModule,
  ModalModule,
  PageHeaderModule,
  ProgressbarModule,
  QueryBuilderModule,
  TabsModule,
  TagModule,
  TooltipModule,
} from '@giglio-com/ng-libraries/dist';
import { SidenavComponent } from './core/components/sidenav/sidenav.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { SidenavService } from './core/services/sidenav.service';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { environment } from 'src/environments/environment';
import { ViewportSizeModule } from './shared/directives/viewport-size/viewport-size.module';
import { TranslocoRootModule } from './transloco-root.module';
import { OutsideClickModule } from './shared/directives/outside-click/outside-click.module';
import { MenuComponent } from './core/containers/menu/menu.component';
import { FusionAuthModule } from '@fusionauth/angular-sdk';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { UserService } from './core/services/user.service';
import CanActivateLogged from './core/guards/logged';
import { MenuService } from './core/services/menu.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ComponentsModule } from './core/components/components.module';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { ProfileComponent } from './features/profile/profile.component';
import { InstanaService } from './core/services/instana.service';
registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    TestModalComponent,
    TestComponentComponent,
    SidenavComponent,
    DashboardComponent,
    ProfileComponent,
    MenuComponent,
    ConfirmModalComponent,
  ],
  imports: [
    FusionAuthModule.forRoot({
      clientId: environment.clientId,
      serverUrl: environment.serverUrl,
      redirectUri: environment.callback,
    }),
    ComponentsModule,
    BrowserModule,
    AppRoutingModule,
    CKEditorModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ApolloModule,
    HttpClientModule,
    LayoutModule,
    ViewportSizeModule,
    OutsideClickModule,
    TooltipModule,
    CardModule,
    IconModule,
    ModalModule,
    ActionBarModule,
    DropdownModule,
    BoxModule,
    GridModule,
    HeadingModule,
    PageHeaderModule,
    DrawerModule,
    FormModule,
    ProgressbarModule,
    TagModule,
    TabsModule,
    QueryBuilderModule,
    DataTableModule,
    LabelModule,
    CalendarViewModule,
    TranslocoRootModule,
    FormsModule,
    BoxModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    SidenavService,
    CanActivateLogged,
    MenuService,
    UserService,
    { provide: LOCALE_ID, useValue: 'it' },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink) => {
        return {
          cache: new InMemoryCache(),
          defaultOptions: {
            watchQuery: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'ignore',
            },
            query: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'all',
            },
          },
          /*link: httpLink.create({
            uri: environment.graphql,
            withCredentials: true,
          }),*/
          link: ApolloLink.from([
            onError(({ graphQLErrors, networkError, response }) => {
              if (graphQLErrors && graphQLErrors.length > 0) {
                if ((graphQLErrors[0] as any)?.statusCode == 401) {
                  console.error(`[Client side error]: ${graphQLErrors[0].message}`);
                }
              }
              if (networkError) {
                console.error(`[Network error]: ${networkError.message}`);
              }
            }),
            httpLink.create({
              uri: environment.graphql,
              withCredentials: true,
            }),
          ]),
        };
      },
      deps: [HttpLink],
    },
    { provide: ErrorHandler, useClass: InstanaService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
